class AppTeam {
  constructor() {
    if(!document.querySelector('#AppMain')){
      return
    }

    this.btn = document.querySelector('#AppMain .js-AppTeamBtn')
    this.btns_remove = document.querySelectorAll('#AppMain .js-AppTeamBtnRemove')
    this.tabs = document.querySelectorAll('#AppMain .app-field-team')

    this.btns_remove.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.remove()
      })
    })

    this.btn.addEventListener('click', () => {
      this.add()
    })
  }

  remove = () => {
    const visible = document.querySelectorAll('#AppMain .app-field-team:not(.hide)')
    const visibleLast = visible[visible.length - 1]
    const fields = visibleLast.querySelectorAll('input')
    const hiddenRequriedFields = visibleLast.querySelectorAll('input.is-required')

    fields.forEach(input => {
      input.value = ""
    });

    hiddenRequriedFields.forEach(input => {
      input.removeAttribute('required')
    });

    visibleLast.classList.add('hide')
    this.btn.classList.remove('disabled')
  }

  add = () => {
    const hidden = document.querySelector('#AppMain .app-field-team.hide')
    const hiddenRequriedFields = hidden.querySelectorAll('input.is-required')

    if(hidden){
      hidden.classList.remove('hide')

      hiddenRequriedFields.forEach(input => {
        input.setAttribute('required', 'required')
      });

      const hidden2 = document.querySelector('#AppMain .app-field-team.hide')
      if(!hidden2) {
        this.btn.classList.add('disabled')
      }
    }
  }

}

new AppTeam()
